import makeActionCreator from 'src/lib/makeActionCreator';

export const SET_FORM_STATUS = 'SET_FORM_STATUS';
export const RESET_FORM_STATUS = 'RESET_FORM_STATUS';

export const setFormStatus = makeActionCreator(SET_FORM_STATUS);
export const resetFormStatus = makeActionCreator(RESET_FORM_STATUS);
